import React, { useMemo } from 'react'
import { useLanguage } from '../../../../../stores/LanguageStore';
import { Flex, Group, Stack, Text } from '@mantine/core';
import MainTable from '../../../../../layouts/Table/MainTable';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { detectUnsubscriberTypeFromValue } from '../../listUtils';

const allColumnFields = ["email", "domain_email", "linkedin_url", "company", "phone", "siren", "siret", "naf_code"];

const StepPreviewUnsub = ({
    data,
}) => {
    const lang = useLanguage((s) => s.language);
    const apiRef = useGridApiRef();

    const columns = useMemo(() => {
        return allColumnFields.map((field) => (
            {
                field: field,
                headerName: lang.unsubscribers.columns[field],
                width: 150,
                filterable: false,
                sortable: false,
                id: field,
            }
        ))
    }, [lang.unsubscribers.columns]);

    let rows = useMemo(() => {
        return data.map((row, index) => {
            let parsedRow = detectUnsubscriberTypeFromValue(row.value)
            console.log(parsedRow);

            let newRow = { id: index };
            allColumnFields.forEach((field) => {
                newRow[parsedRow.unsubscriberType] = parsedRow.value;
            });
            return newRow;
        })
    }, [data])

    return (
        <Stack
            gap={"xs"}
            flex={"1 1 auto"}
            h={0}
            style={{ overflow: "auto" }}
            mih={435}
        >
            <Text>Prévisuel de la désinscription de vos données</Text>

            <Flex h={0} flex={1} mt={10}>
                <MainTable
                    isClient={false}
                    apiRef={apiRef}
                    columns={columns}
                    rows={rows}
                    id={"list-table"}
                    withBorderTop
                    disableCheckboxes
                    disableGotoPage
                    disableFilter
                    disablePerPage
                    // disableSearch
                    disableVisibleColumns
                />
            </Flex>
        </Stack>
    )
}

export default StepPreviewUnsub